import localeEn from "@/i18n/locales/en";
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  locale: "en",
  legacy: false,
  fallbackLocale: "en",
  messages: {
    en: localeEn,
  },
});

export default i18n;
